<template>
  <div class="home">
    <v-card flat>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="8">
            <latest-updates></latest-updates>
          </v-col>
          <v-col cols="12" sm="4">
            <SerialNumberSearch
              :searchPassed="[]"
              :loadingData="loadingData"
              v-on:serialSearching="serialSearching"
              direction="vertical"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <DataTable
              :optionsPassed="options"
              :totalEsvs="totalEsvs"
              :esvs="esvs"
              :searchPassed="search"
              :headerSelects="headerSelects"
              :headersTable="headersTable"
              v-on:getEsvs="getEsvs"
              :loading="loading"
              :allowIgnoreServiceLimitTIme="$can('DisplayAll', 'ESVDatatable')"
            >
              <template #title>
                <v-icon left>mdi-filter</v-icon>Overview
              </template>
            </DataTable>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src
import DataTable from "@/components/ESV/DataTable.vue";

// var searchTimeOut;

export default {
  name: "Home",
  components: {
    DataTable,
    // EsvOverview,
    SerialNumberSearch: () =>
      import("@/components/Search/SerialNumberSearch.vue"),
    LatestUpdates: () => import("@/components/ESV/LatestUpdates.vue"),
    // SerialNumberSearch: () => import('@/components/Search/SerialNumberSearch.vue')
  },
  data: () => ({
    esvs: [],
    search: [],
    loadingData: false,
    options: { /*itemsPerPage: 15*/ },
    totalEsvs: null,
    headerSelects: [{ serviceRequestType: [] }, { status: [] }],
    headersTable: [
      {
        text: "Type",
        value: "serviceRequestType",
        type: "select",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Dossier",
        value: "esvReference",
        type: "text",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Description",
        value: "subject",
        type: "text",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Service Grade",
        value: "serviceGrade",
        type: "select",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Product Group",
        value: "productGroup",
        type: "select",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Product Subgroup",
        value: "productSubGroup",
        type: "select",
        class: "text-subtitle-1 font-weight-bold",
      },
    ],
    loading: false,
  }),
  computed: {},
  methods: {
    getEsvs(tableSearch) {
      this.loading = true;
      this.search = tableSearch.search;
      this.options = tableSearch.options;
      this.$api
        .getEsvOverview(tableSearch)
        .then((resp) => {
          this.esvs = resp.data.esvs;
          this.totalEsvs = resp.data.totalEsvs;
          // this.esvs = resp.data.esvs
          // this.totalEsvs = resp.data.totalEsvs
        })
        .finally(() => (this.loading = false));
    },
    serialSearching(serialSearch) {
      this.$router.push({ name: "SerialSearch", params: { serialSearch } });
    },
  },
};
</script>
